import type { Messages } from './en'

export const zhHant: Messages = {
  'lang.label': '語言',
  'lang.en': 'English',
  'lang.ja': '日本語',
  'lang.zhHant': '繁體中文',

  'common.back': '← 返回',
  'common.cancel': '取消',
  'common.save': '儲存',
  'common.saving': '儲存中…',
  'common.loading': '載入中…',
  'common.previous': '上一個',
  'common.next': '下一個',
  'common.dismiss': '關閉',
  'common.ok': '確定',
  'common.clear': '清除',
  'common.play': '播放',
  'common.pause': '暫停',
  'common.start': '開始',
  'common.end': '結束',
  'common.technique': '技法',
  'common.techniques': '技法列表',
  'common.status': '狀態',
  'common.configured': '已設定',
  'common.unset': '未設定',
  'common.opensNewTab': '（在新分頁開啟）',

  'library.eyebrow': 'Judo',
  'library.title': '形 KATA',
  'library.subtitle': '選擇形',
  'library.kodokan': 'KODOKAN',
  'library.dataLink': '匯出、匯入或重設本機資料',
  'library.manualLink': '使用說明',
  'library.homeScreenTitle': '加到主畫面',
  'library.homeScreenBody':
    '把這個應用加到主畫面，之後可以更快開啟，並以全螢幕方式練習。',
  'library.homeScreenInstall': '安裝應用',
  'library.homeScreenInstalling': '正在開啟安裝…',
  'library.homeScreenIosStep1': '用 Safari 開啟本網站。',
  'library.homeScreenIosStep2': '點選分享按鈕（方框與向上箭頭）。',
  'library.homeScreenIosStep3': '選擇「加入主畫面」，再點「加入」。',
  'library.homeScreenAndroidStep1': '用 Chrome（或 Edge）開啟本網站。',
  'library.homeScreenAndroidStep2': '點選瀏覽器選單（⋮）。',
  'library.homeScreenAndroidStep3':
    '選擇「安裝應用程式」或「加到主畫面」，然後確認。',
  'library.waitlistTitle': '雲端同步',
  'library.waitlistBody':
    '可選的付費多裝置備份。免費的本機優先使用方式維持不變。先了解效益與預計價格，再加入候補名單。',
  'library.waitlistLearnMore': '了解雲端同步',
  'library.feedbackTitle': '意見回饋',

  'cloudSync.documentTitle': '雲端同步 | 柔道形練習工具',
  'cloudSync.backToLibrary': '← 返回形一覽',
  'cloudSync.openData': '本機匯出／匯入',
  'cloudSync.openDisclaimer': '免責聲明',
  'cloudSync.eyebrow': '可選付費方案',
  'cloudSync.title': '雲端同步',
  'cloudSync.subtitle':
    '讓形的筆記、錨點與偏好設定跨裝置延續。免費的本機練習維持不變。',
  'cloudSync.status': '候補名單階段 — 尚未開賣。只有足夠人數報名，我們便會開發同步功能。',
  'cloudSync.compareTitle': '免費與雲端同步',
  'cloudSync.compareLead':
    '雲端同步備份的是你個人的練習資料，並不解鎖形內容或 YouTube 影片。',
  'cloudSync.freeTitle': '本機永遠免費',
  'cloudSync.freeItem1': '完整形練習與評分 — 無需帳號',
  'cloudSync.freeItem2': 'YouTube 參考、錨點、筆記與收藏存於 IndexedDB',
  'cloudSync.freeItem3': '資料頁可手動 JSON 匯出／匯入',
  'cloudSync.freeItem4': '首次造訪後，應用程式殼層可離線使用',
  'cloudSync.paidTitle': '啟用雲端同步後',
  'cloudSync.paidItem1': '個人中繼資料自動備份到雲端',
  'cloudSync.paidItem2': '登入後，手機與筆電使用同一套設定',
  'cloudSync.paidItem3': '清除瀏覽器或更換裝置時可還原',
  'cloudSync.paidItem4': '偏好設定與形資料一併同步',
  'cloudSync.notIncludedTitle': '購買範圍之外',
  'cloudSync.notIncludedBody':
    'YouTube 影片維持免費，由使用者自行提供。v1 雲端同步不託管影片、不販售形媒體，也不含教練／團隊共用。取消訂閱會暫停同步，裝置上的本機資料仍會保留。',
  'cloudSync.howTitle': '預計運作方式',
  'cloudSync.howLead': '候補名單達標並開始收費後的預計流程。',
  'cloudSync.howStep1': '以魔術連結登入（電子郵件、無需密碼）。',
  'cloudSync.howStep2': '訂閱雲端同步後，本機儲存會在背景同步。',
  'cloudSync.howStep3':
    '本機資料仍是權威來源。若裝置內容衝突，以最新的雲端寫入為準，並顯示簡短提示。',
  'cloudSync.pricingTitle': '預計價格',
  'cloudSync.pricingLead': '所有付費方案的功能相同，差別只在計費週期。',
  'cloudSync.planMonthlyName': '月繳',
  'cloudSync.planMonthlyPrice': 'US$2',
  'cloudSync.planMonthlyPeriod': '/ 月',
  'cloudSync.planHalfYearName': '半年',
  'cloudSync.planHalfYearPrice': 'US$11',
  'cloudSync.planHalfYearPeriod': '/ 6 個月',
  'cloudSync.planHalfYearNote': '適合一季訓練週期',
  'cloudSync.planYearlyName': '年繳',
  'cloudSync.planYearlyPrice': 'US$20',
  'cloudSync.planYearlyPeriod': '/ 年',
  'cloudSync.planYearlyNote': '最划算',
  'cloudSync.pricingPhilosophy':
    '價格旨在涵蓋託管與登入郵件成本，讓免費本機應用得以持續。你付的是資料同步，不是 YouTube 或形的內容。',
  'cloudSync.waitlistTitle': '加入候補名單',
  'cloudSync.waitlistBody':
    '寄信表達興趣。至少十人報名，我們便會開發雲端同步。這不是購買。',
  'cloudSync.waitlistCta': '以電子郵件加入候補名單',
  'cloudSync.waitlistSubject': '雲端同步候補名單',
  'cloudSync.waitlistEmailBody':
    '你好，\n\n我想加入柔道形應用的雲端同步候補名單。\n\n謝謝！',

  'library.feedbackBody':
    '對本應用有想法、問題或建議？歡迎寄信給開發者，我們會逐一閱讀。',
  'library.feedbackCta': '以電子郵件傳送回饋',
  'library.feedbackSubject': '柔道形應用意見回饋',
  'library.disclaimer':
    '個人影片網址與錨點僅儲存在此裝置。清除瀏覽器資料可能會移除它們。影片播放需要連線至 YouTube。',

  'practice.changeKata': '← 更換形',
  'practice.editVideoAnchors': '編輯影片',
  'practice.configureVideo': '設定影片',
  'practice.judgePerformance': '評分演武',
  'practice.pastScores': '過往得分',
  'practice.backToJudging': '← 返回評分',
  'practice.label': '練習',
  'practice.selectTechnique': '選擇技法',
  'practice.selectTechniquePrompt': '請選擇要觀看動作的技法。',
  'practice.category': '分類',
  'practice.timingNotSet': '尚未設定時間',
  'practice.timingNotSetFor':
    '{name} 尚未設定時間。你可以觀看完整影片，或開啟編輯器設定開始與結束。',
  'practice.addVideoTitle': '新增影片',
  'practice.addVideoBody':
    '{kata} 尚未設定 YouTube 參照。請設定線上影片以練習技法區段。',
  'practice.addVideoBodyScoring':
    '{kata} 尚未設定 YouTube 參照。你仍可先評分演武；若要練習技法區段或觀看參考影片，再新增影片即可。',
  'practice.addVideo': '新增影片',
  'practice.editAnchors': '編輯錨點',
  'practice.segment': '區段',
  'practice.playbackGroup': '區段播放',
  'practice.playSegment': '播放區段',
  'practice.playing': '播放中…',
  'practice.replay': '重播',
  'practice.playVideo': '播放影片',
  'practice.meta': '{count} 個技法 · 影片 ID {videoId}',
  'practice.disclaimer':
    '網址與錨點儲存在此裝置，而非影片本身。播放需要網路連線。',
  'practice.loadError': '無法載入本機資料。',

  'setup.editTitle': '編輯影片',
  'setup.configureTitle': '設定影片',
  'setup.bannerHint': '線上 YouTube 參照',
  'setup.urlLabel': 'YouTube 網址',
  'setup.urlHint': 'youtube.com/watch、youtu.be 或嵌入網址。不支援上傳。',
  'setup.titleLabel': '參照標題（選填）',
  'setup.titleHint': '只編輯標題會保留既有技法時間。',
  'setup.titlePlaceholder': '{kata} 參照',
  'setup.preview': '預覽',
  'setup.unsaved': '尚未儲存的變更',
  'setup.identityWarning':
    '此影片 ID 與已儲存的參照不同{timings}。儲存會清除既有技法時間，避免被靜默重用。請再次按下「確認取代」以繼續，或只編輯標題以保留目前影片的時間。',
  'setup.timingsCount': '（{count} 個技法時間）',
  'setup.confirmReplace': '確認取代',
  'setup.saveReference': '儲存參照',
  'setup.continue': '繼續',
  'setup.removeVideo': '移除影片',
  'setup.removing': '移除中…',
  'setup.removeConfirm':
    '要移除 {kata} 已儲存的 YouTube 參照嗎？此影片的技法時間會被刪除。技法目錄不受影響。筆記與最愛會保留。',
  'setup.discardConfirm': '要捨棄尚未儲存的變更嗎？',
  'setup.saveFailed': '儲存失敗。本機資料未更新。',
  'setup.removeFailed': '移除失敗。本機資料未更新。',
  'setup.disclaimer':
    '網址儲存在此裝置。影片不會下載。播放需要網路連線。',

  'youtube.error.empty': '請輸入 YouTube 網址。',
  'youtube.error.invalid': '請輸入有效的 YouTube 網址（youtube.com 或 youtu.be）。',
  'youtube.error.unsupportedHost': '僅支援 YouTube 網址。',
  'youtube.error.missingId': '無法在該網址中找到有效的 YouTube 影片 ID。',
  'youtube.error.invalidId': '無效的影片 ID。',
  'youtube.error.html5': 'HTML5 播放器錯誤。',
  'youtube.error.notFound': '找不到影片或影片為私人。',
  'youtube.error.embedDisabled': '此影片已停用嵌入。',
  'youtube.error.playback': '播放錯誤（代碼 {code}）。請試試其他影片。',
  'youtube.error.loadFailed': '無法載入 YouTube 播放器。',
  'youtube.noVideo': '尚未設定影片。',
  'youtube.loadingPlayer': '載入播放器中…',
  'youtube.loadVideo': '載入影片',
  'youtube.loadVideoHint':
    '節省行動數據 — 僅在載入或播放時才開始串流。',
  'youtube.dataSaver.title': '節省行動數據',
  'youtube.dataSaver.on': '開',
  'youtube.dataSaver.off': '關',
  'youtube.dataSaver.explanation':
    '開啟時，應用程式先顯示輕量海報，直到你載入影片、預覽或播放才開始 YouTube 串流。只瀏覽技法清單不會下載影片。關閉時，只要顯示參照就會立即載入播放器。',
  'youtube.dataSaver.explanationShort':
    '開：先顯示海報，載入或播放後才串流。關：立即載入播放器。',
  'youtube.dataSaver.note':
    '這不會下載或儲存影片檔。播放仍需要網路。偏好設定儲存在此裝置，並會包含在 JSON 匯出中。',
  'youtube.offline':
    '離線 — 無法播放。此裝置上已儲存的網址與錨點仍可編輯。',
  'youtube.referenceVideo': '參照影片',

  'anchors.pageTitle': '技法錨點',
  'anchors.editorTitle': '錨點編輯器',
  'anchors.needVideo': '請先設定 YouTube 參照再編輯錨點。',
  'anchors.configureVideo': '設定影片',
  'anchors.changeRemoveVideo': '變更 / 移除影片',
  'anchors.heroMeta': '{kata} · 已設定 {configured}/{total}',
  'anchors.allTechniques': '所有技法',
  'anchors.sideHint': '演武順序 · 可編輯任一技法',
  'anchors.durationPending':
    '時長驗證待定 — 播放器回報時長前無法以影片長度驗證結束點。你仍可儲存有效的開始 < 結束範圍。',
  'anchors.overlapWarning': '重疊警告（不阻擋）：此範圍與 {names} 重疊。',
  'anchors.unsaved': '尚未儲存的時間變更',
  'anchors.boundTo': '綁定影片 {videoId}',
  'anchors.overview': '時間總覽',
  'anchors.startBeforeEnd': '開始必須早於結束。',
  'anchors.endAfterStart': '結束必須晚於開始。',
  'anchors.startWithinDuration': '開始必須在影片時長範圍內。',
  'anchors.endWithinDuration': '結束必須在影片時長範圍內。',
  'anchors.setBothFirst': '請先設定開始與結束。',
  'anchors.setBothBeforeSave': '儲存前請先設定開始與結束。',
  'anchors.saved': '已儲存在此裝置。',
  'anchors.savedPending': '已儲存在此裝置。播放器回報時長前，時長驗證仍待定。',
  'anchors.overlapNote': ' 重疊警告（不阻擋）：{names}。',
  'anchors.clearConfirm': '要清除此技法的開始/結束嗎？已儲存的時間會被移除。',
  'anchors.cleared': '已在此裝置清除時間。',
  'anchors.clearFailed': '清除失敗。本機資料未更新。',
  'anchors.discardConfirm': '要捨棄尚未儲存的時間變更嗎？',
  'anchors.discardTechniqueConfirm': '要捨棄此技法尚未儲存的時間變更嗎？',
  'anchors.loadError': '無法載入已儲存的參照。',
  'anchors.saveFailed': '儲存失敗。本機資料未更新。',
  'anchors.disclaimer':
    '錨點、筆記與最愛會對此 YouTube 參照儲存在此裝置。取代影片會清除時間（筆記/最愛保留）。影片本身不會下載。',

  'controls.captureGroup': '擷取目前時間',
  'controls.setStartHere': '設為開始',
  'controls.setEndHere': '設為結束',
  'controls.jumpGroup': '跳至錨點',
  'controls.jumpStart': '跳至開始',
  'controls.jumpEnd': '跳至結束',
  'controls.seekGroup': '搜尋控制',
  'controls.previewSegment': '預覽區段',

  'timeline.start': '開始 {time}',
  'timeline.end': '結束 {time}',
  'timeline.now': '目前 {time}',
  'timeline.duration': '時長 {time}',
  'timeline.durationPending': '時長待定 — 播放器回報時長前驗證未完成',
  'timeline.startHandle': '開始錨點 {time}。可用方向鍵調整。',
  'timeline.endHandle': '結束錨點 {time}。可用方向鍵調整。',
  'timeline.playhead': '播放頭 {time}',

  'personal.title': '個人',
  'personal.favourite': '最愛',
  'personal.favouriteOn': '★ 最愛',
  'personal.favouriteOff': '☆ 最愛',
  'personal.noteLabel': '{name} 的筆記',
  'personal.notePlaceholder': '筆記（儲存在此裝置）',
  'personal.noteHint':
    '豐富文字僅儲存在此裝置。已停用媒體嵌入；內容不會以 HTML 執行。',
  'personal.saveNote': '儲存筆記',
  'personal.deleteNote': '刪除筆記',
  'personal.unsavedNote': '尚未儲存的筆記',
  'personal.loading': '載入個人資料中…',
  'personal.loadError': '無法載入個人資料。',
  'personal.noteSaved': '已在此裝置儲存筆記。',
  'personal.noteCleared': '已在此裝置清除筆記。',
  'personal.noteDeleted': '已在此裝置刪除筆記。',
  'personal.noteSaveFailed': '筆記儲存失敗。本機資料未更新。',
  'personal.noteDeleteConfirm': '要刪除 {name} 的筆記嗎？',
  'personal.noteDeleteFailed': '無法刪除筆記。',
  'personal.favouriteFailed': '無法更新最愛。',
  'personal.showNotes': '筆記',
  'personal.hideNotes': '隱藏筆記',
  'personal.fullScreenNote': '全螢幕筆記',
  'personal.notesPanel': '技法筆記',
  'personal.closeNotes': '關閉筆記',

  'manual.eyebrow': '指南',
  'manual.title': '使用說明',
  'manual.subtitle':
    '自行設定 YouTube 參照、標記技法錨點、練習形，並評分演武 — 無需帳號。',
  'manual.tocTitle': '本指南內容',
  'manual.backToLibrary': '返回形目錄',
  'manual.openData': '開啟本機資料',

  'manual.overviewTitle': '這個應用能做什麼',
  'manual.overviewLead':
    '這是以本機為主的形練習工具。YouTube 參照由你提供；時間、筆記、最愛與練習評分保存在此瀏覽器。',
  'manual.overviewStep1': '瀏覽七種講道館形，技法列表依演武順序排列。',
  'manual.overviewStep2': '貼上你選擇的 YouTube 網址 — 應用不會內建預設影片目錄。',
  'manual.overviewStep3':
    '為各技法標記開始與結束並練習片段播放，或以 IJF 風格基準評分演武（影片仍需連網）。',

  'manual.chooseTitle': '選擇形',
  'manual.chooseLead': '從首頁目錄開始 — 點選卡片即可進入該形的練習畫面。',
  'manual.chooseStep1': '在首頁七張形卡片中選一張。',
  'manual.chooseStep2': '需要換形時，使用「更換形」回到目錄。',
  'manual.chooseStep3': '若該形有分類，先選分類，再選技法。',

  'manual.videoTitle': '新增 YouTube 參照',
  'manual.videoLead':
    '練習需要每個形一個線上 YouTube 參照。設定與日常觀看畫面分開。',
  'manual.videoStep1': '在形畫面點「設定影片」或「編輯影片」。',
  'manual.videoStep2': '貼上 youtube.com、youtu.be 或嵌入網址。標題為選填。',
  'manual.videoStep3': '預覽播放器後儲存。網址僅保存在此裝置。',
  'manual.videoStep4':
    '更換或移除影片也在同一設定畫面確認 — 換成不同影片 ID 會清除技法時間。',
  'manual.videoNote': '不支援上傳或本機影片檔。播放一律串流自 YouTube。',
  'manual.demoFiguresTitle': '示範參考影片',
  'manual.figDemoAlt':
    'Perfect Nage No Kata 的 YouTube 縮圖 — 可開啟，或貼到「設定影片」試用',
  'manual.figDemoCaption': '示範 — Perfect Nage No Kata（YouTube）',
  'manual.figDemoL1':
    '點縮圖可在新分頁開啟 https://www.youtube.com/watch?v=URH_OKRN9bs。',
  'manual.figDemoL2':
    '也可把該網址貼到「設定影片」，用此參照練習錨點與片段播放。',

  'manual.anchorsTitle': '標記技法錨點',
  'manual.anchorsLead': '錨點是已儲存參照影片上，單一技法的開始與結束時間。',
  'manual.anchorsStep1': '開啟「編輯影片」，再從列表選技法。',
  'manual.anchorsStep2': '用 ±1 秒 / ±5 秒、播放/暫停，或點時間軸軌道跳到目標位置。',
  'manual.anchorsStep3':
    '使用「設為開始」「設為結束」，或輸入時間戳（mm:ss 或 hh:mm:ss）。',
  'manual.anchorsStep4':
    '拖曳時間軸上的開始／結束把手 — 兩者不可交叉。用預覽片段檢查範圍。',
  'manual.anchorsStep5': '範圍正確後按儲存。其他技法可先保持未設定。',
  'manual.anchorsNote':
    '有未儲存變更離開前會提醒。精度依 YouTube 播放器盡力而為，非逐格精確。',

  'manual.figuresTitle': '設定流程畫面',
  'manual.figOpenAlt': '尚未設定參照時的形練習畫面，可見「設定影片」與「新增影片」',
  'manual.figOpenCaption': '1 — 從形練習畫面開啟設定',
  'manual.figOpenL1': '使用頁首的「設定影片」。',
  'manual.figOpenL2': '若尚未設定影片，「新增影片」會進入相同流程。',
  'manual.figOpenL3': '技法仍可選取；儲存影片後再標記時間。',

  'manual.figVideoAlt': '設定影片畫面，含 YouTube 網址欄、選填標題與預覽',
  'manual.figVideoCaption': '2 — 貼上 YouTube 參照',
  'manual.figVideoL1': '貼上 youtube.com、youtu.be 或嵌入網址。',
  'manual.figVideoL2': '標題為選填 — 只改標題會保留既有時間。',
  'manual.figVideoL3': '預覽播放器後儲存。網址僅保存在此裝置。',

  'manual.figEditorAlt': '錨點編輯畫面，含技法列表、播放器與開始／結束時間軸',
  'manual.figEditorCaption': '3 — 錨點編輯版面',
  'manual.figEditorL1': '從列表選取要計時的技法。',
  'manual.figEditorL2': '在播放器觀看參照（需連網）。',
  'manual.figEditorL3': '拖曳時間軸上的開始（S）與結束（E）把手 — 兩者不可交叉。',

  'manual.figMarkAlt': '錨點控制項，含時間軸、設為開始／結束、微調、預覽與儲存',
  'manual.figMarkCaption': '4 — 標記、預覽並儲存',
  'manual.figMarkL1': '查看時間軸上方的開始、目前、結束與片長。',
  'manual.figMarkL2': '拖曳 S/E 把手，或用「設為開始／結束」、輸入時間戳來設定。',
  'manual.figMarkL3': '用 ±1 秒／±5 秒微調，再按「預覽片段」檢查範圍。',
  'manual.figMarkL4': '範圍正確後按「儲存」。取消會捨棄未儲存的變更。',

  'manual.dataSaverTitle': '節省行動數據（YouTube）',
  'manual.dataSaverLead':
    '可選設定：延後 YouTube 串流，直到你選擇載入或播放 — 適合行動數據。',
  'manual.dataSaverStep1':
    '從首頁頁尾開啟「本機資料」，或使用練習畫面上的「節省行動數據」控制項。',
  'manual.dataSaverStep2':
    '保持開啟會先顯示海報；只有在載入影片、預覽或播放後才開始串流。',
  'manual.dataSaverStep3':
    '若希望一顯示參照就立即載入播放器，請關閉此選項。',
  'manual.dataSaverNote':
    '已儲存的網址仍不是已下載的影片。此開關只控制線上串流何時開始。',

  'manual.practiceTitle': '練習技法',
  'manual.practiceLead': '日常練習使用簡潔觀看畫面：選技法、看片段、繼續下一個。',
  'manual.practiceStep1': '選技法。若已設定時間，播放器會跳到開始。',
  'manual.practiceStep2': '用「播放片段」從開始播到結束附近暫停；「重播」回到開始。',
  'manual.practiceStep3': '未設定的技法仍可開啟 — 可看完整影片，或進編輯器補時間。',
  'manual.practiceStep4': '上一個／下一個依演武順序，到列表兩端會停用。',

  'manual.judgeTitle': '評分演武',
  'manual.judgeLead':
    '練習評分可讓搭檔或教練依 IJF 風格基準為一次演武打分，並在本機保存歷史。評分不一定需要 YouTube 參照。',
  'manual.judgeStep1': '在形練習畫面點「評分演武」，進入演武紀錄頁。',
  'manual.judgeStep2': '點「開始評分」建立新場次；若有進行中的草稿，可「繼續」。',
  'manual.judgeStep3':
    '依序處理各評分要素。在觀察項目上點小（−1）、中（−3）、大（−5）以套用或取消扣分。',
  'manual.judgeStep4':
    '技法遺漏時使用「遺忘／省略」— 該要素得 0 分，且形的總分會減半。',
  'manual.judgeStep5':
    '可選：為單一要素留下評語，或「觀看參考」回到該技法的練習畫面。',
  'manual.judgeStep6':
    '完成後點「儲存到歷史」。可在演武紀錄查看過往場次、總分與進步趨勢。',
  'manual.judgeNote':
    '僅供練習輔助，非正式比賽成績。評分保存在此裝置，並會包含在本機資料匯出中。',

  'manual.notesTitle': '筆記與最愛',
  'manual.notesLead': '不必離開練習畫面，就能為各技法留下個人提示。',
  'manual.notesStep1': '在技法開啟「筆記」，撰寫或編輯保存在此裝置的文字。',
  'manual.notesStep2': '切換「最愛」標記想快速找到的技法。',
  'manual.notesStep3': '筆記是給你自己看的內容，絕不會當 HTML 執行。',

  'manual.backupTitle': '備份與還原',
  'manual.backupLead':
    '個人資料都在此瀏覽器。換裝置或清除網站資料前，請先匯出 JSON。',
  'manual.backupStep1': '從首頁頁尾開啟「本機資料」（或在儲存警告後開啟）。',
  'manual.backupStep2': '匯出 JSON 以下載參照、時間、筆記、最愛、評分演武與偏好設定。',
  'manual.backupStep3':
    '匯入會在驗證預覽後取代全部個人資料 — 需要還原請先匯出。輸入 RESET 可重設。',
  'manual.backupNote':
    '清除瀏覽器或網站資料可能刪除本機記錄。備份絕不包含影片檔。',

  'manual.installTitle': '安裝與離線使用',
  'manual.installLead':
    '加到主畫面可更快開啟。成功造訪一次後，應用介面可離線重開。',
  'manual.installStep1': '在首頁依瀏覽器步驟完成「加到主畫面」。',
  'manual.installStep2': '安裝（或首次載入）後，介面與已存本機資料在離線時仍可用。',
  'manual.installStep3': '有新版本時，請先儲存或取消進行中的編輯再重新載入。',
  'manual.installNote':
    '已儲存的 YouTube 網址不是已下載影片 — 播放仍需要網際網路。',

  'data.title': '本機資料',
  'data.lead':
    '匯出、匯入或重設此瀏覽器中的個人資料。絕不包含影片檔 — 僅 YouTube 參照、時間、筆記、最愛與偏好設定。',
  'data.prefsSaveFailed': '無法儲存偏好設定。請再試一次。',
  'data.onDevice': '此裝置上',
  'data.references': '{count} 個影片參照',
  'data.timings': '{count} 個技法時間',
  'data.notes': '{count} 則筆記',
  'data.favourites': '{count} 個最愛',
  'data.performances': '{count} 次評分演武',
  'data.loadingCounts': '載入數量中…',
  'data.storageHint':
    '清除網站/瀏覽器資料也可能移除這些記錄。瀏覽器儲存不是可靠備份。',
  'data.export': '匯出',
  'data.exportBody':
    '下載含結構版本的個人資料 JSON 備份。建議在匯入或重設前執行。',
  'data.exportJson': '匯出 JSON',
  'data.exportStatus':
    '已匯出 {references} 個參照、{notes} 則筆記、{favourites} 個最愛。檔案僅儲存在此裝置。',
  'data.exportFailed': '匯出失敗。',
  'data.import': '匯入（全部取代）',
  'data.importBody':
    '寫入前會驗證完整檔案。成功匯入會原子性取代目前個人資料。無效檔案不會變更既有資料。',
  'data.exportFirst': '先匯出目前資料',
  'data.chooseFile': '選擇 JSON 檔',
  'data.importPreview': '匯入預覽',
  'data.importPreviewWarn': '確認後將取代此裝置上目前所有個人資料。',
  'data.schemaExported': '結構 v{version} · 匯出時間 {date}',
  'data.schemaOnly': '結構 v{version}',
  'data.previewReferences': '{count} 個參照',
  'data.previewTimings': '{count} 個時間',
  'data.previewNotes': '{count} 則筆記',
  'data.previewFavourites': '{count} 個最愛',
  'data.previewPerformances': '{count} 次評分演武',
  'data.preferencesIncluded': '偏好設定：包含',
  'data.preferencesEmpty': '偏好設定：空白',
  'data.cancelImport': '取消匯入',
  'data.confirmImport': '確認全部取代匯入',
  'data.importConfirm':
    '要用匯入內容取代此裝置上的全部個人資料嗎？目前的參照、時間、筆記、最愛與偏好設定會被覆寫。除非你已先匯出備份，否則無法復原。',
  'data.importApplied': '已套用匯入。此裝置上的個人資料已取代。',
  'data.importReadFailed': '無法讀取匯入檔案。',
  'data.importWriteFailed': '匯入寫入失敗。先前本機資料應未變更。',
  'data.reset': '重設本機資料',
  'data.resetBody':
    '永久刪除此裝置上的個人參照、時間、筆記、最愛與偏好設定。形目錄不會被刪除。',
  'data.resetLabel': '輸入 RESET 以啟用',
  'data.resetButton': '重設本機個人資料',
  'data.resetTypeError': '請在確認欄輸入 RESET 以啟用本機資料重設。',
  'data.resetConfirm':
    '要刪除此裝置上所有個人影片參照、時間、筆記、最愛、評分演武與偏好設定嗎？技法目錄不受影響。此操作無法復原。',
  'data.resetDone': '已清除此裝置上的本機個人資料。',
  'data.resetFailed': '重設失敗。本機資料未清除。',
  'data.loadError': '無法讀取本機資料。',

  'scoring.hubLabel': '練習評分',
  'scoring.hubTitle': '演武紀錄',
  'scoring.backPractice': '← 練習',
  'scoring.backPerformances': '← 演武紀錄',
  'scoring.newPerformance': '開始評分',
  'scoring.resumeDraft': '繼續進行中的評分',
  'scoring.latest': '最新 {score} / {max}',
  'scoring.deltaUp': '較上次 +{delta}',
  'scoring.deltaDown': '較上次 {delta}',
  'scoring.improvement': '進步趨勢',
  'scoring.improvementEmpty': '將幾次演武存入紀錄後即可看到得分變化。',
  'scoring.past': '過往演武',
  'scoring.empty': '尚無評分演武。開始一次練習評分。',
  'scoring.statusComplete': '已儲存',
  'scoring.statusDraft': '進行中',
  'scoring.resume': '繼續',
  'scoring.open': '開啟',
  'scoring.delete': '刪除',
  'scoring.deleteConfirm': '要從此裝置刪除此演武嗎？',
  'scoring.judgeLabel': '評分中',
  'scoring.scoreBar': '{total} / {max}',
  'scoring.reviewed': '已檢視 {reviewed} / {total}',
  'scoring.halfPenaltyOn': '半分罰則 開啟',
  'scoring.halfPenaltyOff': '半分罰則 關閉',
  'scoring.complete': '存入紀錄',
  'scoring.elements': '評分項目',
  'scoring.mistakesOnElement': '此項目的失誤 — 點選嚴重程度以套用',
  'scoring.suggested': '建議 {kind}',
  'scoring.severitySmall': '輕微',
  'scoring.severityMedium': '中等',
  'scoring.severityBig': '重大',
  'scoring.forgotten': '遺忘 / 省略',
  'scoring.forgottenHint': '此項目得 0 分，並將整套形總分減半。',
  'scoring.elementComment': '評分者備註（選填）',
  'scoring.elementCommentPlaceholder': '針對此技法／項目的備註…',
  'scoring.elementCommentHint': '只會保存在此項目，不是整場演武的備註。',
  'scoring.applied': '已套用減分 → {points} / 10',
  'scoring.prevElement': '上一項目',
  'scoring.nextElement': '下一項目',
  'scoring.watchReference': '觀看參考影片',
  'scoring.completeTitle': '儲存此演武',
  'scoring.scoredBy': '評分者（選填）',
  'scoring.note': '備註（選填）',
  'scoring.unreviewedWarn':
    '尚有 {count} 個項目未檢視。未檢視項目仍以 10 分計入。仍要存入紀錄嗎？',
  'scoring.saveComplete': '存入紀錄',
  'scoring.readOnly': '已儲存 · 唯讀',
  'scoring.duplicateNew': '重新開始評分',
  'scoring.unsupported': '此形的練習評分尚未提供。',
  'scoring.loadError': '無法載入評分資料。',
  'scoring.disclaimer':
    '採用 IJF 風格準則的練習工具，並非正式比賽成績。準則原文 © IJF Kata Commission。',
  'scoring.criteriaSourceLabel': '演武評分準則：',
  'scoring.criteriaNotifyCta': '通知有較新版本',
  'scoring.criteriaNotifySubject': 'IJF 形評分準則有較新版本',
  'scoring.criteriaNotifyBody':
    '你好，\n\n應用程式目前使用的演武評分準則為：\n{title}\n{url}\n\n已有較新版本發布。\n\n謝謝！',
  'scoring.translationDisclaimer':
    '評分準則譯文為非官方翻譯，可能不夠準確。評分時請以英文準則為準。',
  'scoring.showEnglishCriteria': '顯示英文',
  'scoring.showTranslatedCriteria': '顯示譯文',
  'scoring.kindSmall': '輕微',
  'scoring.kindMedium': '中等',
  'scoring.kindSmallMedium': '輕微/中等',
  'scoring.kindBig': '重大',
  'scoring.kindForgotten': '遺忘',

  'pwa.skipLink': '跳至主要內容',
  'pwa.offline':
    '你目前離線。應用程式介面與已儲存本機資料仍可使用。YouTube 播放需要網路 — 已儲存的網址不是已下載的影片。',
  'pwa.offlineReady':
    '已可離線使用。個人資料仍留在此瀏覽器；影片播放仍需要連線。',
  'pwa.persistDenied':
    '儲存空間不足時，瀏覽器可能清除本機資料。需要時請從「本機資料」匯出備份。',
  'pwa.updateRegion': '有可用的應用程式更新',
  'pwa.updateReady': '新版本已就緒。',
  'pwa.reload': '準備好時重新載入',
  'pwa.notNow': '暫時不要',
  'pwa.updateBlocked': '重新載入以套用更新前，請先儲存或取消目前的編輯。',
}
